import { useEffect } from "react";
import FilterPanel from "./FilterPanel";

interface MobileFilterSheetProps {
  open: boolean;
  onClose: () => void;
  genres: string[];
  year: string;
  region: string;
  onToggleGenre: (genre: string) => void;
  onYearChange: (year: string) => void;
  onRegionChange: (region: string) => void;
  onReset: () => void;
  activeCount: number;
  resultCount: number;
}

export default function MobileFilterSheet({
  open,
  onClose,
  genres,
  year,
  region,
  onToggleGenre,
  onYearChange,
  onRegionChange,
  onReset,
  activeCount,
  resultCount,
}: MobileFilterSheetProps) {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[60] lg:hidden flex flex-col bg-background-50 animate-fade-in">
      <div className="h-16 px-4 flex items-center justify-between border-b border-background-200 shrink-0">
        <div className="flex items-center gap-2">
          <span className="font-heading text-base text-foreground-950">筛选影片</span>
          {activeCount > 0 && (
            <span className="px-1.5 py-0.5 rounded bg-primary-100 text-primary-700 text-[11px] font-label">
              已选 {activeCount}
            </span>
          )}
        </div>
        <button
          type="button"
          onClick={onClose}
          aria-label="关闭筛选面板"
          className="w-9 h-9 flex items-center justify-center rounded-md border border-background-300 text-foreground-700 cursor-pointer"
        >
          <i className="ri-close-line text-lg w-5 h-5 flex items-center justify-center"></i>
        </button>
      </div>

      <div className="flex-1 overflow-y-auto px-4 py-4">
        <FilterPanel
          genres={genres}
          year={year}
          region={region}
          onToggleGenre={onToggleGenre}
          onYearChange={onYearChange}
          onRegionChange={onRegionChange}
          onReset={onReset}
          activeCount={activeCount}
        />
      </div>

      <div className="p-4 border-t border-background-200 shrink-0">
        <button
          type="button"
          onClick={onClose}
          className="w-full h-11 rounded-md bg-primary-600 text-background-50 text-sm whitespace-nowrap cursor-pointer"
        >
          查看 {resultCount} 部影片
        </button>
      </div>
    </div>
  );
}